<template>
  <div class="RecentNew" v-if="RecentNewData">
    <div class="RecentNew_box">
      <!-- <div class="titleName">
        <img src="../../../assets/image/Index/RecentNew.png" alt />
      </div> -->
      <!-- top -->
      <div class="top_list">
        <div class="left_box" @click="toArticles(RecentNewData[0].id)">
          <div class="left_box_content" :style="`--background:#fff`">
            <div class="left_box_content_img_box">
              <img :src="`${GLOBAL.imageUrl}${RecentNewData[0].icon}`" alt />
            </div>

            <div class="date">{{ RecentNewData[0].releaseTime }}</div>
            <div class="content_test">
              <div class="content_test_p_box">
                <p class="content_test_p">{{ RecentNewData[0].title }}</p>
              </div>
              <div
                v-html="
                  $options.filters.formatTime(RecentNewData[0].content, 60, 80)
                "
              ></div>
            </div>
          </div>
        </div>
        <div class="right_box" @click="toArticles(RecentNewData[1].id)">
          <div class="right_box_content" :style="`--background:${RecentNewData[1].sdgColor}`">
            <div class="right_box_content_img_box">
              <img :src="`${GLOBAL.imageUrl}${RecentNewData[1].icon}`" alt />
            </div>
            <div class="date">{{ RecentNewData[1].releaseTime }}</div>
            <div class="content_test">
              <div class="content_test_p_box">
                <span class="content_test_p">{{ RecentNewData[1].title }}</span>
              </div>

              <div
                v-html="
                  $options.filters.formatTime(RecentNewData[1].content, 60, 110)
                "
              ></div>
            </div>
          </div>
        </div>
      </div>

      <!-- bottom -->
      <div class="bottom_list">
        <div class="bottom_left_box">
          <div
            class="bottom_box_content"
            v-for="(item, index) in RecentNewData.slice(2, 4)"
            :key="index"
            @click="toArticles(item.id)"
            :style="`--background:${item.sdgColor}`"
          >
            <div class="bottom_box_content_img_box">
              <img :src="`${GLOBAL.imageUrl}${item.icon}`" alt />
            </div>
            <div class="date">{{ item.releaseTime }}</div>
            <div class="content_test">
              <div class="content_test_p_box">
                <span class="content_test_p">{{ item.title }}</span>
              </div>
              <div v-html="$options.filters.formatTime(item.content, 60, 90)"></div>
            </div>
          </div>
        </div>
        <div class="bottom_right_box" @click="toArticles(RecentNewData[4].id)">
          <div class="bottom_box_content" :style="`--background:${RecentNewData[4].sdgColor}`">
            <div class="bottom_box_content_img_box">
              <img :src="`${GLOBAL.imageUrl}${RecentNewData[4].icon}`" alt />
            </div>
            <div class="date">{{ RecentNewData[4].releaseTime }}</div>
            <div class="content_test">
              <div class="content_test_p_box">
                <span class="content_test_p">{{ RecentNewData[4].title }}</span>
              </div>
              <div
                v-html="
                  $options.filters.formatTime(RecentNewData[4].content, 60, 90)
                "
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["RecentNewData"],
  data() {
    return {
      topData: null,
      bottomData: null
    };
  },
  filters: {
    formatTime: function(value, language, zhNum, enNum) {
      var msg = value.replace(/<\/?[^>]*>/g, " "); //去除HTML Tag
      msg = msg.replace(/[|]*\n/, ""); //去除行尾空格
      msg = msg.replace(/&nbsp;/gi, ""); //去掉npsp
      return msg.slice(0, zhNum).concat("......");
      // if (language == "zh") {
      //   return msg.slice(0, zhNum).concat("......");
      // } else {
      //   return msg.slice(0, enNum).concat("...");
      // }
    }
  },
  watch: {},
  mounted() {},

  methods: {
    toArticles(id) {
      this.$router.push(`/articles?id=${id}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.RecentNew {
  width: 100%;
  height: 1270px;
  // z-index: 99;
  background: rgba(218, 218, 218, 0.3);
  //   z-index: 999;
  .RecentNew_box {
    position: relative;
    top: -120px;
    z-index: 99;
    width: 1200px;
    padding-bottom: -60px;
    margin: auto;
    display: flex;
    flex-direction: column;
    // background: #FBFBFB;
    .titleName {
      width: 128px;
      font-weight: 600;
      font-size: 30px;
      height: 38px;
      color: #fff;
      margin-bottom: 38px;
      img {
        object-fit: cover;
        width: 100%;
      }
    }
    .top_list {
      display: flex;
      flex-direction: row;
      .left_box {
        height: 600px;
        padding: 0 10px 0px 0px;
        flex: 2;
        cursor: pointer;
        &:hover img {
          // opacity: 0.5;
          transition: 0.8s ease;
          transform: scale(1.2, 1.2);
        }
        .left_box_content {
          position: relative;
          border-radius: 4px;
          height: 600px;
          width: 778px;
          &::before {
            content: "";
            display: block;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            border-radius: 5px;
            background-color: var(--background);
            opacity:.8;
            transition: all 0.2s cubic-bezier(0.55, 0.085, 0.68, 0.53),
              background-color 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);
            box-shadow: 0px 6px 8px #ccc;
          }
          &:hover::before {
            top: -15px;
            right: -15px;
            bottom: -15px;
            left: -15px;
            border-radius: 5px;
            transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
            box-shadow: 0px 6px 8px #ccc;
          }
          &:hover .content_test_p {
            background-size: 100% 2px !important;
          }
          &:hover .left_box_content_img_box::after {
            z-index: 33 !important;
            opacity: 0.4 !important;
            transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
          }
          .left_box_content_img_box {
            height: 405px;
            width: 100%;
            border-radius: 4px;
            overflow: hidden;
            position: relative;
            &::after {
              box-sizing: border-box;
              word-wrap: break-word;
              content: "";
              opacity: 0;
              background-image: linear-gradient(to bottom, transparent, #000);
              transition: opacity 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
            }

            &::before {
              content: "";
              display: block;
            }
            img {
              object-fit: cover;
              transition: 0.8s ease;
              width: 100%;
              height: 100%;
            }
          }
          .date {
            margin-top: 22px;
            width: 138px;
            height: 32px;
            border-radius: 0px 4px 4px 0px;
            border: 1px solid #333;
            font-size: 18px;
            font-family: Avenir-Medium, Avenir;
            font-weight: 500;
            color: #000;
            line-height: 32px;
            text-align: center;
          }
          .content_test {
            width: 100%;
            padding: 0 20px;
            .content_test_p {
              margin-top: 14px;
              font-size: 32px;
              overflow: hidden; //超出的文本隐藏
              text-overflow: ellipsis; //用省略号显示
              white-space: nowrap; //不换行
              // font-weight: 600;
              color: #000;
              background-image: linear-gradient(#333, #333);
              background-position: left bottom;
              background-repeat: no-repeat;
              transition: background-size 0.2s
                cubic-bezier(0.55, 0.085, 0.68, 0.53);
              text-decoration: none;
              background-size: 0px 2px;
            }
            div {
              margin-top: 4px;
              font-size: 16px;
              color: #000;
            }
          }
        }
      }
      .right_box {
        height: 600px;
        cursor: pointer;
        padding: 0 0px 0 10px;
        flex: 1;
        &:hover img {
          transition: 0.8s ease;
          transform: scale(1.2, 1.2);
          // opacity: 0.5;
        }

        .right_box_content {
          position: relative;
          border-radius: 4px;
          height: 100%;
          width: 100%;

          &::before {
            content: "";
            display: block;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            border-radius: 5px;
            background-color: var(--background);
            opacity:.8;
            transition: all 0.2s cubic-bezier(0.55, 0.085, 0.68, 0.53),
              background-color 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);
            box-shadow: 0px 6px 8px #ccc;
          }
          &:hover::before {
            top: -15px;
            right: -15px;
            bottom: -15px;
            left: -15px;
            border-radius: 5px;
            transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
            box-shadow: 0px 6px 8px #ccc;
          }
          &:hover .content_test_p {
            background-size: 100% 2px !important;
          }
          &:hover .right_box_content_img_box::after {
            z-index: 33 !important;
            opacity: 0.4 !important;
            transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
          }
          // box-shadow: 0px 6px 5px #ccc;
          .right_box_content_img_box {
            height: 264px;
            width: 400px;
            border-radius: 4px;
            overflow: hidden;
            position: relative;
            &::after {
              box-sizing: border-box;
              word-wrap: break-word;
              content: "";
              opacity: 0;
              background-image: linear-gradient(to bottom, transparent, #000);
              transition: opacity 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
            }

            &::before {
              content: "";
              display: block;
            }
            img {
              object-fit: cover;
              transition: 0.8s ease;
              width: 100%;
              height: 100%;
            }
          }
          .date {
            margin-top: 20px;
            width: 138px;
            height: 32px;
            border-radius: 0px 4px 4px 0px;

            border: 1px solid #fff;
            font-size: 18px;
            font-family: Avenir-Medium, Avenir;
            font-weight: 500;
            color: #fff;
            line-height: 32px;
            text-align: center;
          }
          .content_test {
            width: 100%;
            padding: 0 20px;
            .content_test_p_box {
              word-wrap: break-word;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              margin-top: 7px;
              font-size: 31px;
              color: #fff;
              margin-bottom: 8px;
              .content_test_p {
                background-image: linear-gradient(#fff, #fff);
                background-position: left bottom;
                background-repeat: no-repeat;
                transition: background-size 0.2s
                  cubic-bezier(0.55, 0.085, 0.68, 0.53);
                text-decoration: none;
                background-size: 0px 2px;
              }
            }

            div {
              margin-top: 14px;
              font-size: 16px;
              color: #fff;
              opacity: 0.9;
            }
          }
        }
      }
    }
    .bottom_list {
      margin-top: 40px;
      display: flex;
      flex-direction: row;

      .bottom_left_box {
        width: 778px;
        display: flex;
        flex-direction: row;
        margin-right: 10px;
        height: 600px;
        .bottom_box_content:first-child {
          margin-right: 10px;
        }
        .bottom_box_content:last-child {
          margin-left: 10px;
        }
        .bottom_box_content {
          cursor: pointer;
          width: 378px;
          height: 100%;
          position: relative;
          border-radius: 4px;
          &::before {
            content: "";
            display: block;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            border-radius: 5px;
            background-color: var(--background);
            opacity:.8;
            transition: all 0.2s cubic-bezier(0.55, 0.085, 0.68, 0.53),
              background-color 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);
            box-shadow: 0px 6px 8px #ccc;
          }
          &:hover::before {
            top: -15px;
            right: -15px;
            bottom: -15px;
            left: -15px;
            border-radius: 5px;
            transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
            box-shadow: 0px 6px 8px #ccc;
          }
          &:hover .content_test_p {
            background-size: 100% 2px !important;
          }
          &:hover .bottom_box_content_img_box::after {
            z-index: 33 !important;
            opacity: 0.4 !important;
            transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
          }
          &:hover img {
            transition: 0.8s ease;
            transform: scale(1.2, 1.2);
          }
          // box-shadow: 0px 6px 5px #ccc;
          .bottom_box_content_img_box {
            height: 264px;
            width: 100%;
            border-radius: 4px;
            overflow: hidden;
            position: relative;
            &::after {
              box-sizing: border-box;
              word-wrap: break-word;
              content: "";
              opacity: 0;
              background-image: linear-gradient(to bottom, transparent, #000);
              transition: opacity 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
            }

            &::before {
              content: "";
              display: block;
            }
            img {
              object-fit: cover;
              width: 100%;
              height: 100%;
              transition: 0.8s ease;
            }
          }

          .date {
            margin-top: 20px;
            width: 138px;
            height: 32px;
            border-radius: 0px 4px 4px 0px;

            border: 1px solid #fff;
            font-size: 18px;
            font-family: Avenir-Medium, Avenir;
            font-weight: 500;
            color: #fff;
            line-height: 32px;
            text-align: center;
          }
          .content_test {
            width: 100%;
            padding: 0 20px;
            .content_test_p_box {
              word-wrap: break-word;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              margin-top: 7px;
              font-size: 31px;
              color: #fff;
              margin-bottom: 8px;
              .content_test_p {
                background-image: linear-gradient(#fff, #fff);
                background-position: left bottom;
                background-repeat: no-repeat;
                transition: background-size 0.2s
                  cubic-bezier(0.55, 0.085, 0.68, 0.53);
                text-decoration: none;
                background-size: 0px 2px;
              }
            }

            div {
              margin-top: 14px;
              font-size: 16px;
              color: #fff;
              opacity: 0.9;
            }
          }
        }
      }
      .bottom_right_box {
        cursor: pointer;
        flex: 1;
        margin-left: 10px;
        height: 600px;
        position: relative;
        border-radius: 4px;
        &::before {
          content: "";
          display: block;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          border-radius: 5px;
          background-color: rgb(63, 126, 68);
          transition: all 0.2s cubic-bezier(0.55, 0.085, 0.68, 0.53),
            background-color 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);
          box-shadow: 0px 6px 8px #ccc;
        }
        &:hover::before {
          top: -15px;
          right: -15px;
          bottom: -15px;
          left: -15px;
          border-radius: 5px;
          transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
          box-shadow: 0px 6px 8px #ccc;
        }
        &:hover .content_test_p {
          background-size: 100% 2px !important;
        }
        &:hover .bottom_box_content_img_box::after {
          z-index: 33 !important;
          opacity: 0.4 !important;
          transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
        }
        &:hover img {
          transition: 0.8s ease;
          transform: scale(1.2, 1.2);
        }
        .bottom_box_content {
          width: 100%;
          height: 100%;
          .bottom_box_content_img_box {
            height: 264px;
            width: 100%;
            overflow: hidden;
            position: relative;
            &::after {
              box-sizing: border-box;
              word-wrap: break-word;
              content: "";
              opacity: 0;
              background-image: linear-gradient(to bottom, transparent, #000);
              transition: opacity 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
            }

            &::before {
              content: "";
              display: block;
            }
          }
          img {
            object-fit: cover;
            height: 100%;
            width: 100%;
            transition: 0.8s ease;
          }
          .date {
            margin-top: 20px;
            width: 138px;
            height: 32px;
            border-radius: 0px 4px 4px 0px;

            border: 1px solid #fff;
            font-size: 18px;
            font-family: Avenir-Medium, Avenir;
            font-weight: 500;
            color: #fff;
            line-height: 32px;
            text-align: center;
          }
          .content_test {
            padding: 0 20px;
            .content_test_p_box {
              word-wrap: break-word;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
              overflow: hidden;
              margin-top: 7px;
              font-size: 31px;
              color: #fff;
              margin-bottom: 8px;
              .content_test_p {
                background-image: linear-gradient(#fff, #fff);
                background-position: left bottom;
                background-repeat: no-repeat;
                transition: background-size 0.2s
                  cubic-bezier(0.55, 0.085, 0.68, 0.53);
                text-decoration: none;
                background-size: 0px 2px;
              }
            }
            div {
              margin-top: 14px;
              font-size: 16px;
              color: #fff;
              opacity: 0.9;
            }
          }
        }
      }
    }
  }
}
</style>